import { TranslationState } from './types/TranslationState';

export default ({
  translation,
}: {
  translation: TranslationState;
}): TranslationState => translation;
